import powerDeliveryHeroImg from 'images/expertise/power-delivery/PowerDeliveryHero.webp';
import powerInfrastructureSolutionsImg from 'images/expertise/power-delivery/PowerInfrastructureSolutions.webp';

export const powerDeliveryHero = (powerDeliveryHeroImg as any).src || powerDeliveryHeroImg;
export const powerInfrastructureSolutions = (powerInfrastructureSolutionsImg as any).src || powerInfrastructureSolutionsImg;